import React from "react";
import { SlideDown } from "react-slidedown";
export default class ZipCheckResults extends React.Component {
    // componentDidUpdate(prevProps: IZipCheckProps){
    //     if(
    //         prevProps.checkingZip !== this.props.checkingZip ||
    //         prevProps.showZipMessage !== this.props.showZipMessage ||
    //         prevProps.zipResult !== this.props.zipResult
    //     ){
    //         //this.forceUpdate()
    //     }
    // }
    render() {
        const { checkingZip, showZipMessage, zipResult } = this.props;
        return (React.createElement(SlideDown, { closed: !checkingZip && !showZipMessage },
            checkingZip && (React.createElement("div", { className: "spinner-border text-success", role: "status" },
                React.createElement("span", { className: "visually-hidden" }, "Loading..."))),
            (showZipMessage && zipResult) && (React.createElement("div", { className: "alert alert-success mb-3" }, "Great! We deliver directly to you!")),
            (showZipMessage && !zipResult) && (React.createElement("div", { className: "alert alert-danger mb-3" }, "Sorry! We don't deliver in your area at the moment. But you can pickup an order from our stores"))));
    }
}
